import { DeleteOutlined, FileZipOutlined, MinusOutlined, PlusOutlined, SendOutlined } from "@ant-design/icons";
import React from "react";
import { Text } from "react-native";
import {Button as AntButton, Flex, Input, Modal, Popover, Badge, List} from "antd";
import { useReport } from "../hooks/useReport";
import {
  useEmailWorkOrdersMutation,
  useGetWorkOrderReportsZipMutation
} from "../../../store/services/api/report-api";
import {BasketInstance, BasketItem} from "../../../hooks/useBasket";

export const Basket = ({basket}: {basket: BasketInstance}) => {
  const [emailReports, {isLoading: emailsLoading}] = useEmailWorkOrdersMutation();
  const {downloadReport: downloadZip, isLoading: zipLoading} = useReport({query: useGetWorkOrderReportsZipMutation});
  const isLoading = zipLoading || emailsLoading;
  const emailRef = React.useRef("");

  const removeFromBasket = (id: string) => {
    basket.removeItems(id)
  }

  const clearAllFromBasket = () => {
    basket.clearAll();
  }

  const handleDownloadZip = () => {
    downloadZip({
      workOrderIds: basket.selectedItems.map(w => w.id)
    }, 'application/zip')
  }

  const handleEmailWorkOrders = () => {
    Modal.confirm({
      title: "Send Work Order Reports",
      content: (
        <Input
          placeholder="Enter recipient email"
          onChange={(e) => {
            emailRef.current = e.target.value;
          }}
        />
      ),
      onOk: async () => {
        const ids = basket.selectedItems.map(w => w.id);
        await emailReports({ workOrderIds: ids, email: emailRef.current });
      }
    });
  };

  const basketList = () => {
    if (basket.selectedItems.length == 0) {
      return <Text>No work orders in basket.</Text>
    }

    return (
      <div style={{minWidth: 300}}>
        <List
          loading={isLoading}
          style={{
            height: 300,
            overflow: 'auto',
            padding: '0 16px',
            border: '1px solid rgba(140, 140, 140, 0.35)',
          }}
          dataSource={basket.selectedItems}
          renderItem={(item: BasketItem) => (
            <List.Item key={item.id}>
              <List.Item.Meta
                title={<span>{item.label}</span>}
              />
              <AntButton
                onClick={() => removeFromBasket(item.id)}
                icon={<DeleteOutlined size={24} />}
              />
            </List.Item>
          )}
        />

        <Flex justify='space-between' gap={6} style={{marginBlock: 12}}>
          <AntButton
            onClick={handleDownloadZip}
            icon={<FileZipOutlined />}
            loading={zipLoading}
            disabled={isLoading}
            block
          >
            ZIP
          </AntButton>

          <AntButton
            onClick={handleEmailWorkOrders}
            icon={<SendOutlined />}
            loading={emailsLoading}
            disabled={isLoading}
            block
          >
            Email
          </AntButton>
        </Flex>

        <AntButton
          onClick={clearAllFromBasket}
          icon={<DeleteOutlined />}
          disabled={isLoading}
          block
          danger
        >
          Clear
        </AntButton>
      </div>
    )
  }

  return (
    <Popover content={basketList} trigger={"click"} placement="bottomLeft">
      <AntButton size='large'>
        <Badge
          count={basket.selectedItems.length}
          color='rgb(44, 137, 198)'
        />
        Basket
      </AntButton>
    </Popover>
  )
}

export const BasketIcon = ({ isSelected, onToggle }) => {
  return (
    <AntButton
      shape='circle'
      type="text"
      size='small'
      onClick={onToggle}
      icon={isSelected ? <MinusOutlined /> : <PlusOutlined />}
    />
  )
}
